// extracted by mini-css-extract-plugin
export var arrow = "GalleryModule-module--arrow--1NclX";
export var arrowDisabled = "GalleryModule-module--arrowDisabled--jbJjf";
export var arrowIcon = "GalleryModule-module--arrowIcon--suxWx";
export var arrowNext = "GalleryModule-module--arrowNext--4sxTx";
export var arrowPrev = "GalleryModule-module--arrowPrev--slWfK";
export var autoPlayControlIcon = "GalleryModule-module--autoPlayControlIcon--Yl51W";
export var autoplayControl = "GalleryModule-module--autoplayControl--2VTWj";
export var autoplayControlWithCaption = "GalleryModule-module--autoplayControlWithCaption--a7bRE";
export var component = "GalleryModule-module--component--4k7pc";
export var dots = "GalleryModule-module--dots--ZV1tK";
export var inner = "GalleryModule-module--inner--+ygh8";